import { render } from "./TreatmentCard.vue?vue&type=template&id=0145066a&scoped=true&ts=true"
import script from "./TreatmentCard.vue?vue&type=script&lang=ts"
export * from "./TreatmentCard.vue?vue&type=script&lang=ts"

import "./TreatmentCard.vue?vue&type=style&index=0&id=0145066a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0145066a"]])

export default __exports__